import * as React from "react";
import Loading from "components/loading";
import {useEffect, useState} from "react";
import {getNetBankingLink, NetBankingLinkType} from "IncompleteInfoV2/BankStatementV2/BSModes/NetBanking/api";
import {isWebview} from "utils";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {getIdToken} from "service";

interface IProps {
    institutionId: string;
    applicationId: number;
}

const NetBanking = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        (async () => {
            setLoading(true);
            const res = await getNetBankingLink(props.institutionId, props.applicationId);
            if (isWebview()) {
                setAndroidTokenAndVersionBeforeRedirecting(null, getIdToken());
            }
            if (res.type === NetBankingLinkType.URL) {
                window.open(res.value, "_self");
            } else {
                const win = window.open("", "_self");
                win.document.write(res.value);
                const script = document.createElement("script");
                script.innerText = "document.autoform.submit();";
                win.document.head.appendChild(script);
            }
        })();
    }, []);
    return <Loading active={loading}/>;
};

export default NetBanking;
